import { ToastrService } from "ngx-toastr";
import { InitialLoadAction } from "./initial-load-action"
import { Injectable } from "@angular/core";
import { Permission } from "@nucleus/user-ui";
import { ApplicationConfigService } from "../application-config.service";
import { PermissionsService } from "../permission/permissions.service";
import { LoadingService } from "./loading-service";


@Injectable({
    providedIn: 'root'
  })
export class InitPermissionsAction extends InitialLoadAction<boolean> {

    constructor(loadingService : LoadingService, 
        private permissionService : PermissionsService, 
        private configService : ApplicationConfigService,
        private toastrService: ToastrService) {
        super('Permissions', loadingService);
    }

    override onLoad(): Promise<boolean> {
        return new Promise<boolean>(
            (resolve, reject) => {
                this.permissionService.search({ 
                    onStart: () => {},
                    onSuccess: (permissions: Permission[]) => this.configService.setPermissions(permissions),
                    onError: (error: string) => this.toastrService.error(error), 
                    onComplete: () => {resolve(true)}}
                );
            }
        );

    }
}